import { useMemo } from 'react';
import { useDynamicElementHeight } from '../useDynamicElementHeight';
export const useCalculateTopOffset = ()=>{
    const { elementHeight: appBarHeight, elementRef: appBarRef } = useDynamicElementHeight();
    const { elementHeight: clientBarHeight, elementRef: clientBarRef } = useDynamicElementHeight();
    const topOffset = useMemo(()=>appBarHeight || clientBarHeight ? appBarHeight + clientBarHeight : null, [
        appBarHeight,
        clientBarHeight
    ]);
    return {
        topOffset,
        appBarRef,
        clientBarRef
    };
};
